module.exports = __webpack_public_path__ + "static/media/pattern2.acb7355e.png";